<template>
  <pict
    block-name="wave-hero"
    :default="{
      src: $options.image[$i18n.locale].l,
      srcset: {
        '2x': $options.image[$i18n.locale].l2x
      }
    }"
    :sources="[
      {
        media: 's',
        src: $options.image[$i18n.locale].xs,
        srcset: {
          '2x': $options.image[$i18n.locale].xs2x
        }
      }
    ]"
    :alt="alt"
  />
</template>

<script>
import Pict from "@/shared/pict"
import imageL from "./images/learning-that-fits-into-your-life-l-en.png"
import imageL2x from "./images/learning-that-fits-into-your-life-l-en@2x.png"
import imageXs from "./images/learning-that-fits-into-your-life-xs-en.png"
import imageXs2x from "./images/learning-that-fits-into-your-life-xs-en@2x.png"
import imageLDE from "./images/learning-that-fits-into-your-life-l-de.png"
import imageL2xDE from "./images/learning-that-fits-into-your-life-l-de@2x.png"
import imageXsDE from "./images/learning-that-fits-into-your-life-xs-de.png"
import imageXs2xDE from "./images/learning-that-fits-into-your-life-xs-de@2x.png"

export default {
  name: "WaveHero",
  components: {
    Pict
  },
  image: {
    en: {
      l: imageL,
      l2x: imageL2x,
      xs: imageXs,
      xs2x: imageXs2x
    },
    de: {
      l: imageLDE,
      l2x: imageL2xDE,
      xs: imageXsDE,
      xs2x: imageXs2xDE
    }
  },
  props: {
    alt: { type: String, default: "" }
  }
}
</script>

<style lang="scss">
.wave-hero {
  &__picture {
    @include grid-css-element(12);

    position: relative;
    z-index: 1;

    @include media(min-width, m) {
      @include grid-css-element(6);

      &:after {
        content: "";

        position: absolute;
        top: 0;
        left: 100%;
        z-index: 0;

        display: block;
        width: 100vw;
        height: 100%;

        background-color: $blue;
      }
    }
  }

  &__image {
    position: relative;
    left: 50%;
    z-index: 1;

    display: block;
    height: 100%;

    transform: translateX(-50%);

    @include media(min-width, m) {
      position: absolute;
      top: 0;
      left: -6rem;

      transform: translateX(0);
    }

    @include media(min-width, l) {
      left: -9rem;
    }
  }
}
</style>
